module.exports = __webpack_public_path__ + "img/img-gzt-2.6e442e4f.png";